import httpRequest from "@/auth/http-client";
import { LojaIntegradaAccountConnectionFormData } from "@/components/screens/Platforms/LojaIntegradaConnection/LojaIntegradaAccountConnection/types";

class LojaIntegradaService {
  private baseUrl = "api/v1/lojaintegrada";

  async lojaIntegradaSubscription({
    ApiKey,
  }: LojaIntegradaAccountConnectionFormData): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/onboarding`, {
      ApiKey,
    });
    return;
  }

  async lojaIntegradaUnsubscribe(): Promise<void> {
    await httpRequest.post(`${this.baseUrl}/offboarding`, {});
    return;
  }
}

const lojaIntegradaService = new LojaIntegradaService();
export default lojaIntegradaService;
